import { axiosInstance } from '../../../api/client-base.ts';
import InstanceType from '../../../enums/instance-type.ts';

export const getTokensByWallet = async (tokenAddress: string) => {
  return await axiosInstance({
    method: 'GET',
    url: `${InstanceType.Api}/portfolio/GetAccountTokens?address=${tokenAddress}&include_zero_balance=true`,
  });
};
